<footer class="bg-white p-8 md:px-16 border-t border-grey flex flex-row items-center justify-between ">
  <ng-content></ng-content>
</footer>
